"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchingGame = exports.SYMBOLS = void 0;
exports.SYMBOLS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
class MatchingGame {
    random;
    symbols = [];
    matched = new Set();
    pending = null;
    constructor(random = Math.random) {
        this.random = random;
        this.newRound();
    }
    newRound() {
        this.symbols = [...exports.SYMBOLS];
        this.matched.clear();
        this.pending = null;
    }
    dispense() {
        if (this.pending !== null)
            return this.pending;
        if (this.matched.size === this.symbols.length)
            this.newRound();
        const choices = this.symbols.filter(symbol => !this.matched.has(symbol));
        this.pending = choices[Math.floor(this.random() * choices.length)];
        return this.pending;
    }
    place(symbol) {
        if (this.pending === null || this.pending !== symbol || this.matched.has(symbol))
            return false;
        this.matched.add(symbol);
        this.pending = null;
        return true;
    }
}
exports.MatchingGame = MatchingGame;
//# sourceMappingURL=game.js.map